import React from 'react';
import { observer } from 'mobx-react-lite';
import {
    PrimaryButton,
    SecondaryButton,
    UnderlinedButton,
} from '@JohnLewisPartnership/jl-design-system/dist/elements/button/Button';
import WishListStore from '../../../stores/WishListsStore';
import styles from './WishListRemove.module.scss';
import { WISHLIST_URL } from '../../../helpers/redirect/constants';

interface WishListRemoveProps {
    store: WishListStore;
    onClose(): void;
}

export const WishListRemove: React.FC<WishListRemoveProps> = observer(({ store, onClose }) => {
    function onManageWishList(): void {
        window.location.href = `${WISHLIST_URL}`;
    }

    async function onConfirm(): Promise<void> {
        if (store.mode === 'icon-placeholder' || store.mode === 'icon-placeholder-wishlist-recs') {
            await store.removeProductFromWishLists(store.currentProductId, store.mode);
        } else {
            await store.removeSkuFromWishLists(store.currentProductSkuId);
        }
        onClose();
    }

    const variantCount = store.currentProduct?.isMultiSku
        ? store.wishLists.reduce((count, wishlist) => {
              return count + wishlist.products.filter((product) => product.productId === store.currentProductId).length;
          }, 0)
        : 1;

    const wishListsWithSkuCount = store.countWishListsContainingSku();

    return (
        <div className={styles.container}>
            <div>
                {store.mode === 'icon-placeholder-pdp' || store.mode === 'icon-placeholder-basket' ? (
                    <div className={styles.containerPDP}>
                        <div className={styles.title}>Remove from Wishlist</div>
                        <div className={styles.header}>Remove this variation from all lists?</div>
                        <div>This variation will be removed from {wishListsWithSkuCount} of your lists</div>
                    </div>
                ) : (
                    <div>
                        <div className={styles.title}>Remove all variations from your lists?</div>
                        <div>
                            {variantCount} {variantCount > 1 ? 'variations' : 'variation'} of this item will be removed
                            from your list
                        </div>
                    </div>
                )}
            </div>
            <div className={styles.buttonContainer}>
                <UnderlinedButton
                    className={styles.button}
                    size="small"
                    disabled={store.isCallingAPI}
                    onClick={onManageWishList}
                >
                    Manage Lists
                </UnderlinedButton>
                <div className={styles.buttonsRight}>
                    <SecondaryButton
                        className={styles.button}
                        size="small"
                        onClick={onClose}
                        disabled={store.isCallingAPI}
                    >
                        Cancel
                    </SecondaryButton>
                    <PrimaryButton
                        className={styles.button}
                        size="small"
                        onClick={onConfirm}
                        disabled={store.isCallingAPI}
                        submitting={store.isCallingAPI}
                    >
                        Yes, Remove
                    </PrimaryButton>
                </div>
            </div>
        </div>
    );
});
